import { screenIndex } from "@/pages/WorkoutsPage/ui/AnalyticsPage/appSections";
import type { SphereKey } from "../model/spheres";

/**
 * Экран «Как получить баллы» (у администраторов — на месте «Правил» раздела «Баллы»)
 * сразу на карточке сферы: туда ведут окно «за что эти баллы» и шары профиля.
 */
export const pointsRulesHref = (lang: string, sphere: SphereKey): string =>
    `/${lang}/account/analytics?tab=points&s=${screenIndex("points", "rules") + 1}&sphere=${sphere}`;
